module.exports = __webpack_public_path__ + "img/sleeve length.ebfd0867.png";